import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.principal').filter('dotCapitalize', dotCapitalize);

    dotCapitalize.$inject = [];

    function dotCapitalize() {
        return function(path) {
            if (path) {
                return path.replace(/\../, function(a) {
                    return a.toUpperCase();
                });
            }
            return path;
        };
    }
})();
